import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { useAdditionalCoreSeatPricePreSeats, useShowAdditionalSeatsPriceSubtextPreSeats, useShowIncludedSeatsPreSeats, useShowPricePerMonthPerSeatPreSeats } from './useSeatsDisplayPreSeats';
import { useAdditionalCoreSeatPriceTB, useShowAdditionalSeatsPriceSubtextTB, useShowIncludedSeatsTB, useShowPricePerMonthPerSeatTB } from './useSeatsDisplayTB';
export const useShowPricePerMonthPerSeat = ({
  skuId
}) => {
  const isUngatedForSeats = useAppSelector(state => isUngatedForSeatsSelector(state));

  // Call both hooks unconditionally
  const tb = useShowPricePerMonthPerSeatTB({
    skuId
  });
  const preSeats = useShowPricePerMonthPerSeatPreSeats();

  // Select the result based on the gating
  return isUngatedForSeats ? tb : preSeats;
};
export const useShowIncludedSeats = ({
  skuId
}) => {
  const isUngatedForSeats = useAppSelector(state => isUngatedForSeatsSelector(state));

  // Call both hooks unconditionally
  const tb = useShowIncludedSeatsTB({
    skuId
  });
  const preSeats = useShowIncludedSeatsPreSeats();

  // Select the result based on the gating
  return isUngatedForSeats ? tb : preSeats;
};
export const useAdditionalCoreSeatPrice = ({
  skuId
}) => {
  const isUngatedForSeats = useAppSelector(state => isUngatedForSeatsSelector(state));
  const tb = useAdditionalCoreSeatPriceTB({
    skuId
  });
  const preSeats = useAdditionalCoreSeatPricePreSeats();

  // Select the result based on the gating
  return isUngatedForSeats ? tb : preSeats;
};
export const useShowAdditionalSeatsPriceSubtext = ({
  skuId
}) => {
  const isUngatedForSeats = useAppSelector(state => isUngatedForSeatsSelector(state));

  // Call both hooks unconditionally
  const tb = useShowAdditionalSeatsPriceSubtextTB({
    skuId
  });
  const preSeats = useShowAdditionalSeatsPriceSubtextPreSeats();

  // Select the result based on the gating
  return isUngatedForSeats ? tb : preSeats;
};